/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useState, useMemo } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import Input from './Input';
import Image from '@components/global/Image';
import SociollaDateRangePicker from '@components/sociolla/SociollaDateRangePicker';
import { parseDate } from '@global/helpers';
import { INPUT_HEIGHT } from '@/constants';

const DateRangePicker = (props) => {
  const {
    testID = 'date-range-picker',
    label = '',
    hideLabel = false,
    value = null,
    placeholder = 'Select date range',
    disabled = false,
    iconStyle = {},
    style = {},
  } = props;

  const [showPicker, setShowPicker] = useState(false);

  const displayValue = useMemo(() => {
    if (!value?.start) {
      return '';
    }
    const startStr = parseDate(value.start, 'd MMM yyyy');
    if (!value?.end) {
      return startStr;
    }
    const endStr = parseDate(value.end, 'd MMM yyyy');
    if (startStr === endStr) {
      return startStr;
    }
    return `${startStr} - ${endStr}`;
  }, [value]);

  const handleChange = (range) => {
    try {
      props.onChange(range);
      setShowPicker(false);
    } catch (_err) {
      setShowPicker(false);
    }
  };

  return (
    <View testID={testID} style={[{ position: 'relative' }, style || {}]}>
      <TouchableOpacity
        testID={`${testID}-overlay`}
        style={[
          styles.inputDate,
          { height: INPUT_HEIGHT, top: !label || hideLabel ? 0 : 30 },
        ]}
        disabled={disabled}
        activeOpacity={1}
        onPress={() => setShowPicker(true)}
      />
      <Input
        {...props}
        inputContainerStyle={{ height: INPUT_HEIGHT }}
        editable={false}
        value={displayValue}
        placeholder={placeholder}
        rightIcon={
          <View
            style={{
              marginRight: -10,
              ...iconStyle,
            }}>
            <Image
              style={{ width: 23, height: 16 }}
              width={23}
              height={16}
              svg={true}
              source={require('@assets/img/icons/menu/calendar.svg')}
            />
          </View>
        }
      />
      <SociollaDateRangePicker
        visible={showPicker}
        startValue={value?.start || null}
        endValue={value?.end || null}
        onClose={() => setShowPicker(false)}
        onChange={handleChange}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  inputDate: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 2,
    elevation: 2,
  },
});

export default React.memo(DateRangePicker, (prev, next) => prev === next);
